import { z } from "zod";

export const preauth = z.object({
  reauthNecessary: z.boolean(),
});

export type Preauth = z.infer<typeof preauth>;
